import { last, includes } from "ramda"

const castValue = (value) => (typeof value === "string" ? value : "")

const parseFloatValue = (digits) => (value) => {
  let preparedValue = value.replace(new RegExp(",", "g"), ".")

  if (last(preparedValue) === ".") {
    return preparedValue
  }

  const x = parseFloat(preparedValue)
  if (isNaN(x)) return ""

  if (includes(".", preparedValue) && digits) {
    preparedValue = preparedValue.substring(0, preparedValue.indexOf(".") + digits + 1)
  }

  return preparedValue
}

const parseIntValue = (value) => {
  const x = parseInt(value)
  return !isNaN(x) ? x : ""
}

export const parseValue = (type, value, digits) => {
  if (typeof value === "number") return value.toString()

  const parse = type === "double" ? parseFloatValue(digits) : parseIntValue
  const parsed = parse(castValue(value))

  return parsed
}

export const checkAllowedKey = (options) => {
  const { type = "int", which, oldValue, forbidNegative } = options
  const value = castValue(oldValue)

  if (type === "double") {
    if (which === 45) {
      if (value.indexOf("-") !== -1 || forbidNegative) return false
    } else if (which === 46 || which === 44) {
      if (value.indexOf(".") !== -1 || value.indexOf(",") !== -1) return false
    } else if (which < 48 || which > 57) {
      return false
    }
  } else {
    if (which === 45) {
      if (value.indexOf("-") !== -1 || forbidNegative) return false
    } else if (which < 48 || which > 57) {
      return false
    }
  }

  return true
}

export const normalizeChangedValue = (options) => {
  const { type, newValue, forbidNegative, maxLength } = options

  if (!newValue) return ""

  const regexString = forbidNegative
    ? type == "double"
      ? "[0-9]{1," + maxLength + "}([,.]([0-9]{1," + maxLength + "})?)?"
      : "[0-9]{1," + maxLength + "}"
    : type == "double"
    ? "[-]?[0-9]{1," + maxLength + "}([,.]([0-9]{1," + maxLength + "})?)?|^-$"
    : "[-]?[0-9]{1," + maxLength + "}|^-$"
  const regex = new RegExp(regexString)
  const result = ("" + newValue).match(regex)
  return result != null && result[0] ? result[0] : null
}
